import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";

import ConfirmationModal from "../Modals/ConfirmationModal";
import StickyFooter from "../../../components/StickyFooter/StickyFooter";
import { CREATE_TICKET_MAX_SELECTION } from "../../../constants/policies.constants";
import { useSelection } from "../context/SelectionContext";
import { FindingsRequestPayload } from "@repo/api/schemas/policiesFindings.schema";

export default function DetailedFindigsStickyFooter({
  payload,
}: {
  payload: FindingsRequestPayload;
}) {
  const intl = useIntl();
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [hideSelectAllLink, setHideSelectAllLink] = useState(false); // whether user clicked “Select all N records”
  const { selectedRows } = useSelection();
  const prevSelectedRowsLength = useRef(selectedRows.length);

  useEffect(() => {
    if (
      hideSelectAllLink &&
      selectedRows.length !== prevSelectedRowsLength.current
    ) {
      setHideSelectAllLink(false);
    }
    prevSelectedRowsLength.current = selectedRows.length;
  }, [selectedRows.length, hideSelectAllLink]);

  return (
    <>
      <StickyFooter
        variant="findings"
        maxSelection={CREATE_TICKET_MAX_SELECTION}
        primaryButtonText={intl.formatMessage({
          defaultMessage: "Create Ticket",
          description: "Create Ticket Button Text",
          id: "crOKoA",
        })}
        onPrimaryAction={() => {
          setIsConfirmationOpen(true);
        }}
        hideSelectAllLink={hideSelectAllLink}
        setHideSelectAllLink={setHideSelectAllLink}
      />
      {isConfirmationOpen && (
        <ConfirmationModal
          isOpen={isConfirmationOpen}
          setIsOpen={setIsConfirmationOpen}
          selectAllItems={hideSelectAllLink}
          payload={payload}
          onSuccess={() => {
            setHideSelectAllLink(false);
          }}
        />
      )}
    </>
  );
}
